export const handleError = closure => (...args) => {
  try {
    return closure(...args);
  } catch (error) {
    console.error(error);
  }
};



// WEBPACK FOOTER //
// ./app/services/handler-error.js